import React, { useEffect } from 'react'
import img1 from '../assets/Group 726.png';
import { IoCamera } from "react-icons/io5";
import { useState } from 'react';
import img2 from '../assets/Ellipse 68.svg';
import { LuPencilLine } from "react-icons/lu";
import { FaPhoneAlt } from "react-icons/fa";
import { LuGanttChartSquare } from "react-icons/lu";
import TotalAccountsMobile from '../components/TotalAccountsMobile';
import CibilInsightMobile from '../components/CibilInsightMobile';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';
import { MdClose } from 'react-icons/md';

const UserProfileMobile = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    const [profilePic,setProfilePic] = useState(img2);
    const [name, setName] = useState('NAVEEN KUMAR ATAVA');
    const [phone, setPhone] = useState('9089789012');
    const [address, setAddress] = useState('00, Area name, vsp-515151');
    const [dob, setDob] = useState('00/00/0000');
    const [email, setEmail] = useState('google@email.com');
    const [aadhaarNo, setAadhaarNo] = useState('0000 0000');
    const [panNo, setPanNo] = useState('0000 0000 0000');

    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
    const [editedName, setEditedName] = useState(name);
    const [editedPhone, setEditedPhone] = useState(phone);
    const [editedAddress, setEditedAddress] = useState(address);
    const [editedDob, setEditedDob] = useState(dob);
    const [editedEmail, setEditedEmail] = useState(email);
    const [editedAadhaarNo, setEditedAadhaarNo] = useState(aadhaarNo);
    const [editedPanNo, setEditedPanNo] = useState(panNo);

    const toggleEditPopup = () => {
        setIsEditPopupOpen(!isEditPopupOpen);
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        setName(editedName);
        setPhone(editedPhone);
        setAddress(editedAddress);
        setDob(editedDob);
        setEmail(editedEmail);
        setAadhaarNo(editedAadhaarNo);
        setPanNo(editedPanNo);
        setIsEditPopupOpen(false);
        toggleEditPopup();
    };
    const handleImageChange = (event) =>{
        const file = event.target.files[0];
        setProfilePic(file);
    }
    //const [isExpanded, setExpanded] = useState(false);
    // const toggleExpand = () => {
    //     setExpanded(!isExpanded);
    // };
    return (
    <div className='font-sans h-full w-full bg-slate-50 mt-16'>
        <div className={`flex flex-col justify-center items-center transition-all ease-in-out duration-200 bg-white z-40 rounded-lg border overflow-hidden border-primary shadow-xl max-h-[90%] w-[90%] fixed top-[50%] left-[50%] p-2 -translate-x-[50%] -translate-y-[50%] ${isEditPopupOpen ? 'scale-100 opacity-100':'scale-0 opacity-0'}`}>
            <MdClose className='absolute top-0 right-0 m-2 text-lg md:text-2xl cursor-pointer' onClick={toggleEditPopup} />
            <h2 className='text-primary font-semibold text-xl mt-5 mb-2'>ENTER YOUR DETAILS</h2>
            <form className='grid grid-cols-1 px-4 max-h-96 w-full overflow-y-scroll' onSubmit={handleSubmit}>
                <div className="mb-2">
                    <label htmlFor="name" className="block text-black mb-1">User Name</label>
                    <input type="text" value={editedName} onChange={(e) => setEditedName(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="phone" className="block text-black mb-1">Phone</label>
                    <input type="text" id="phone" value={editedPhone} onChange={(e) => setEditedPhone(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="address" className="block text-black mb-1">Address</label>
                    <input type="text" id="address" value={editedAddress} onChange={(e) => setEditedAddress(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="dob" className="block text-black mb-1">Date of Birth</label>
                    <input type="text" id="dob" value={editedDob} onChange={(e) => setEditedDob(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="email" className="block text-black mb-1">Email</label>
                    <input type="text" id="email" value={editedEmail} onChange={(e) => setEditedEmail(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-2">
                    <label htmlFor="aadhaarNo" className="block text-black mb-1">Aadhaar Number</label>
                    <input type="text" id="aadhaarNo" value={editedAadhaarNo} onChange={(e) => setEditedAadhaarNo(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
                <div className="mb-4">
                    <label htmlFor="panNo" className="block text-black mb-1">PAN Number</label>
                    <input type="text" id="panNo" value={editedPanNo} onChange={(e) => setEditedPanNo(e.target.value)} className="w-[90%] border border-gray-400 rounded-md px-3 py-2 focus:outline-none focus:border-primary"/>
                </div>
            </form>
            <button onClick={handleSubmit} className="bg-primary text-white font-bold py-2 px-4 rounded focus:outline-none focus:bg-primary-dark hover:bg-primary-dark w-24">Save</button>
        </div>
        <div className={`flex flex-col justify-centre items-center h-52 w-full bg-primary overflow-visible mb-10 ${isEditPopupOpen? 'blur-sm':''}`}>
            <div className='flex flex-row w-[95%] justify-around items-center my-4 h-full'>
                <div className='h-full flex flex-col justify-end mb-2'><p className='text-white text-md w-24'>YOUR CIBIL INSIGHTS</p></div>
                <img src={img1} alt='meter' width={200} />
            </div>
            <div className='flex flex-row rounded-3xl border-2 border-primary h-52 w-[95%] bg-white p-3'>
                <div className='flex flex-col justify-center items-center w-1/3'>
                    <div className='relative'>
                        <div className='aspect-w-1 aspect-h-1 rounded-full w-20 h-20 overflow-hidden'><img className='object-cover' src={typeof profilePic === 'string' ? profilePic : URL.createObjectURL(profilePic)} width={150} alt=''></img></div>
                        <label
                            htmlFor='imageInput'
                            className='cursor-pointer absolute right-0 bg-white bottom-2 rounded-full p-1'
                        >
                            <IoCamera className='text-xl' />
                        </label>
                        <input
                            id='imageInput'
                            className='hidden'
                            type='file'
                            accept='image/*'
                            onChange={handleImageChange}
                            required
                        />
                    </div>
                    <div className='flex flex-row justify-center w-full'>
                        <button onClick={toggleEditPopup}className="flex flex-row justify-center items-center hover:text-blue-500 gap-1 text-primary rounded-3xl h-6 text-xs"><LuPencilLine />Edit Details</button>
                    </div>
                </div>
                <div className='flex flex-col justify-center items-center w-2/3 gap-1'>
                    <h2 className='text-md font-semibold'>{name}</h2>
                    <div className='flex flex-col items-start gap-1'>
                        <p className='flex flex-row text-gray-500 items-center gap-3 text-xs'><FaPhoneAlt/>{phone}</p>
                        <p className='flex flex-row text-gray-500 items-center gap-3 text-xs'><LuGanttChartSquare />{address}</p>
                    </div>
                    {/* {!isExpanded ? 
                        <div className='flex flex-row justify-center items-center mt-2'>
                            <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center hover:text-blue-500 px-2 text-primary text-xs">View More <IoIosArrowDropright className='ml-1'/></button>
                        </div> :
                        <div className='flex flex-row justify-center items-center mt-2'>
                            <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center hover:text-blue-500 px-2 text-primary text-xs">View Less <IoIosArrowDropup className='ml-1'/></button>
                        </div>
                    } */}
                </div>
            </div>
        </div>
        <div className={`flex flex-col justify-center items-center h-full w-full mt-[70px] max-lg:mb-6 ${isEditPopupOpen? 'blur-sm':''}`}>
            <TotalAccountsMobile />
            <div className='grid grid-cols-2 grid-rows-3 place-content-between place-items-center w-[95%] h-72 gap-2 my-2'>
                <CibilInsightMobile title='Home loan'/>
                <CibilInsightMobile title='Credit Cards'/>
                <CibilInsightMobile title='Personal loan'/>
                <CibilInsightMobile title='Vehicle loan'/>
                <CibilInsightMobile title='Other Loans'/>
                <CibilInsightMobile title='Credit Card Enquiries'/>
            </div>
        </div>  
        <p className='sr-only'>KGST</p>
        <Footer/>
    </div>
    )
}

export default UserProfileMobile